import React, { useEffect, useMemo, useState } from 'react';
import { HiOutlinePhotograph } from 'react-icons/hi';
import {
    getProductImageUrl,
    getProductInitials,
    getProductPlaceholderHue,
} from '../../../Utils/productImage';
import './ProductCardImage.css';

function ProductCardImage({ product, productName, alt, className = 'product-img', compact = false }) {
    const imageUrl = useMemo(() => getProductImageUrl(product), [product]);
    const [failedUrl, setFailedUrl] = useState(null);

    useEffect(() => {
        setFailedUrl(null);
    }, [imageUrl]);

    const showImage = Boolean(imageUrl) && failedUrl !== imageUrl;

    if (!showImage) {
        const initials = getProductInitials(productName);
        const hue = getProductPlaceholderHue(
            productName || product?._id || product?.id || 'product'
        );

        return (
            <div
                className={`product-card-image product-img-placeholder ${compact ? 'product-img-placeholder--compact' : ''}`.trim()}
                style={{ '--placeholder-hue': hue }}
                role="img"
                aria-label={alt || productName || 'Product image unavailable'}
            >
                <span className="product-img-placeholder__initials">{initials}</span>
                <HiOutlinePhotograph className="product-img-placeholder__icon" aria-hidden />
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            className={`product-card-image ${className}`.trim()}
            alt={alt || productName || 'Product'}
            loading="lazy"
            decoding="async"
            onError={() => setFailedUrl(imageUrl)}
        />
    );
}

export default ProductCardImage;
